import styled from "@emotion/styled";
import { Container } from "@mui/material";
import React, { useEffect, useState } from "react";
import { BASEURL } from "../../../configure";
import { Content, P } from "../../../styles";

const Wrapper = styled.div`
  background-color: #f5f5ef;
  /* min-height: 100vh; */
  padding: 70px 0;
  display: flex;
  align-items: center;
  text-align: center;
  place-content: center;
  justify-content: center;
`;
const SecionPrimaryPara = styled.div`
  color: #212121;

  text-align: left;
  font-size: 64px;
  font-family: "PlayfairDisplay-SemiBold";
  @media screen and (max-width: 800px) {
    font-size: 44px;
  }
  @media screen and (max-width: 520px) {
    font-size: 35px;
  }
  @media screen and (max-width: 465px) {
    font-size: 30px;
  }
  @media screen and (max-width: 380px) {
    font-size: 24px;
  }
`;
const SecionPrimaryParaItalic = styled.span`
  color: #212121;
  font-size: 26px;
  font-family: "Poppins-SemiBoldItalic";
  padding-left: 10px;
  @media screen and (max-width: 800px) {
    font-size: 20px;
  }
  @media screen and (max-width: 580px) {
    font-size: 15px;
  }
  @media screen and (max-width: 465px) {
    font-size: 12px;
  }
  @media screen and (max-width: 380px) {
    padding-left: 2px;
    font-size: 10px;
  }
`;
const Slidedown = styled.a`
  text-decoration: none;
`;
const ParaDiv = styled.div`
  justify-content: center;
  display: flex;
  text-align: " -webkit-center";
  text-align: "-moz-center";
`;
const Index = () => {
  const [ getContent, setContent ] = useState('')
  let getSectionContent = async () => {
    let projects = await fetch(BASEURL+'section/93?&_embed', {
      method: 'GET',
    })
    const data = await projects.json();
    setContent(data?.content?.rendered)
    
  }
  useEffect(() => {getSectionContent()}, [])
  return (
    <div>
      <Slidedown href="/#ourproject">
        <Wrapper id="primary">
          <Container maxWidth="xl" data-aos="fade-up" data-aos-duration="600" data-aos-easing="ease-in" data-aos-delay="0" data-aos-offset="0" >
            <Content dangerouslySetInnerHTML={{__html: `${getContent}`}} />
          </Container>
        </Wrapper>
      </Slidedown>
    </div>
  );
};

export default Index;
